<template>
    <card class="mb-5">
        <template slot="body">
            <h6 class="heading-small text-muted">Company Basic Information</h6>
            <div class="row">
                <div class="col-sm-12">
                    <form-input placeholder="Business Name" label="Business Name" v-model="form.shop_name" ref="shop_name"></form-input>
                </div>
                <div class="col-lg-5 col-sm-12">
                    <form-select label="Business Type" placeholder="Business Type" :options='businessTypes' v-model="form.shop_type" ref="shop_type"></form-select>
                </div>
                <div class="col-sm-12"></div>
                <div class="col-lg-6 col-sm-12">
                    <form-input label="Business Mobile No." placeholder="13-digit mobile no" :mask="['+639#########']" v-model="form.shop_mobile_no" ref="shop_mobile_no"></form-input>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <form-input label="Business Landline No." placeholder="Business Landline No." :mask="['(0#) ### ####', '(0##) ### ####']" show-optional-label optional-label="(Optional)" v-model="form.shop_landline_no" ref="shop_landline_no"></form-input>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <form-input label="Business Email" placeholder="Business Email" v-model="form.shop_email" ref="shop_email"></form-input>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <form-input label="Website" placeholder="Website" show-optional-label optional-label="(Optional)" v-model="form.shop_website" ref="shop_website"></form-input>
                </div>

                <div class="col-sm-12">
                    <button v-if="!isRequesting" class="btn float-left" @click="back">
                        <i class="fas fa-angle-left mr-2"></i> Back
                    </button>
                    <button v-else class="btn float-left" disabled>
                        <i class="fas fa-angle-left mr-2"></i> Back
                    </button>

                    <button v-if="!isRequesting" class="btn btn-warning float-right" @click="next">
                        Next <i class="fas fa-angle-right ml-2"></i>
                    </button>
                    <button v-else class="btn btn-warning float-right" disabled>
                        <i class="fa fa-spinner fa-spin mr-2"></i> Please wait
                    </button>
                </div>
            </div>
        </template>
    </card>
</template>
<script>
import mixins from "@utils/mixins";
import { validateShopInfo } from "../helpers";

export default {
    name: "BasicInfoSection",
    
    computed: {
        parentFormData() {
            return this.$parent.$parent.data || {};
        }
    },

    data: () => ({
        isRequesting: false,
        form: {
            shop_name: "",
            shop_type: "sole_proprietorship",
            shop_mobile_no: "",
            shop_landline_no: "",
            shop_email: "",
            shop_website: "",
        },
        businessTypes: [
            { value: "sole_proprietorship", text: "Sole Proprietorship" },
            { value: "partnership", text: "Partnership" },
            { value: "corporation", text: "Corporation" },
        ],
    }),

    methods: {
        initialize() {
            this.isRequesting = false;
            this.form = {
                shop_name: this.parentFormData.shop_name || "",
                shop_type: this.parentFormData.shop_type || "sole_proprietorship",
                shop_mobile_no: this.parentFormData.shop_mobile_no || "",
                shop_landline_no: this.parentFormData.shop_landline_no || "",
                shop_email: this.parentFormData.shop_email || "",
                shop_website: this.parentFormData.shop_website || "",
            };
        },
        back() {
            this.$emit("back");
        },
        next() {
            this.isRequesting = true;
            validateShopInfo(this.form)
                .then(response => this.$emit("next", {...this.form}))
                .catch(error => {
                    console.log(error);
                    this.promptFormErrors(this.$refs, error)
                })
                .finally(() => this.isRequesting = false);
        },

    },

    mixins: [mixins],

    mounted() {
        this.initialize();
    }

}
</script>